




import { Component, Vue } from 'vue-property-decorator'
import CallDetail from './components/TicketDetail.vue'

@Component({
  name: 'EditCall',
  components: {
    CallDetail
  }
})
export default class extends Vue {}
